import React, {useState} from "react";
import './Login.css';
import { Google, Facebook, Or, Twitter, Logo } from "../../assets";
import {Link, useHistory} from "react-router-dom";
import { useForm } from "react-hook-form";
// import { Frame } from "../../assets";
import axios from 'axios';
import swal from "sweetalert";

const Signup = () => {
  const { handleChange, errors } = useForm()

  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ value: "" });

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const user = { email, username, password };
    // send the username and password to the server

    const response = await axios.post(
      "https://rewind-test.herokuapp.com/users/sign-up",
      user
    ).then(function (response) {
      setUser(response.data.user)
      // store the user in localStorage
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('user', JSON.stringify(response.data.user));
    })
      .catch(function (error) {
        setErrorMessage((prevState) => ({ value: "Unable to sign up", error }));
      });
    
    // let userInfo = response.data
  };

  const history = useHistory();
  if (user) {
    swal({
      icon: 'success',
      title: "Success!",
      text: "Signup Successful",
      type: "success",
      timer: 2000,
      showConfirmButton: false
    });
    // return <LandingPage user={user.props} handleLogout={handleLogout}/> ;
    history.push("/login");
  }

  
  return (
    <>
      <main className="login-info">
        <section className="d-flex justify-content-center">
          <form className="mt-4 px-5 py-4" onSubmit={handleSignup}>
            <Link to="/" className="click" href="click">
              <img className="d-flex mx-auto" src={Logo} alt="" />
            </Link>
            <h1 className="login-header px-3">Sign Up</h1>
            <p className="px-3 ">Welcome to Rewind</p>
            <label className="login-label mt-3">Username</label>
            <input className="mb-3 login-input" name="username"
              type="text"
              value={username}
              placeholder="Enter your username"
              onChange={({ target }) => setUsername(target.value)}
            />
            
            {errors.username && <p>Username already taken</p>}
          
            <label className="login-label mt-3">Email</label>
            <input className="mb-3 login-input" name="username"
              type="text"
              value={email}
              placeholder="Enter your email"
            onChange={({ target }) => setEmail(target.value)}
            /> 
            {errors.email && <p>Email already taken</p>}
           
            <label className="login-label ml-4">Password</label>
            <input
              className="mb-4 login-input"
              name="password"
              // ref={register}
              type="password"
              value={password}
              placeholder="Enter your password"
              onChange={({ target }) => setPassword(target.value)}
            />
           
            <label className="login-label ml-4">Confirm Password</label>
            <input
              className="mb-4 login-input"
              name="confirmpassword"
              // ref={register}
              type="password"
              value={confirmPassword}
              placeholder="Confirm your password"
              onChange={({ target }) => setConfirmPassword(target.value)}
            />
            {!isLoading ? <button
              className="d-block login-button "
              type="submit"
              value="Submit"
            >
              Sign Up
            </button> :
              <button
                className="d-block login-button "
                type="submit"
                value="Submit"
              >
                Loading.....
              </button>
            }
            {errorMessage.value && (
              <p className="text-danger"> {errorMessage.value} </p>)}
            <p className="or-tag">
              <img src={Or} alt="" />
            </p>
            <div className="login-icons text-center ">
              <a href="./">
                <img src={Facebook} alt="" />
              </a>
              <a href="./">
                <img src={Google} alt="" />
              </a>
              <a href="./">
                <img src={Twitter} alt="" />
              </a>
            </div>
            <p className="text-footer mt-3 ">
              Have an account?
              <Link to="/login" className="click" href="click">
                Click here
              </Link>
            </p>
          </form>
        </section>
      </main>
      {/* <App user={user}/> */}
      {/* <ProtectedRoutes user={user}/> */}
    </>
  );

}

export {Signup};


